import { HttpClient } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';
import { ErrorHandler, Inject, Injectable, Optional } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { scopeSvgFragmentIds } from '../utils/scope-svg-fragment-ids';

/**
 * Ensures each SVG icon instance gets unique fragment ids (`filter`, `clip-path`, gradients,
 * etc.) so `url(#...)` references stay within the correct `<svg>` when many icons exist in the DOM.
 */
@Injectable()
export class ScopedMatIconRegistry extends MatIconRegistry {
  constructor(
    @Optional() httpClient: HttpClient,
    sanitizer: DomSanitizer,
    @Optional() @Inject(DOCUMENT) document: Document | null,
    errorHandler: ErrorHandler,
  ) {
    super(httpClient, sanitizer, document, errorHandler);
  }

  override getNamedSvgIcon(
    name: string,
    namespace = '',
  ): Observable<SVGElement> {
    return super.getNamedSvgIcon(name, namespace).pipe(
      map((svg) => {
        scopeSvgFragmentIds(svg);
        return svg;
      }),
    );
  }

  override getSvgIconFromUrl(safeUrl: SafeResourceUrl): Observable<SVGElement> {
    return super.getSvgIconFromUrl(safeUrl).pipe(
      map((svg) => {
        scopeSvgFragmentIds(svg);
        return svg;
      }),
    );
  }
}
